import { IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';

import { UiTypography } from '@/components/ui/Typography';

import { PaymentSafenessStyles } from './Safeness.styles';

export const PaymentSafeness: React.FC = () => {
  return (
    <PaymentSafenessStyles>
      <UiTypography className="icon-label" variant="body-medium">
        <IonIcon icon={lockClosed} />
        Safe & secure checkout
      </UiTypography>
      <div className="stripe-image">
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/powered_by_stripe.png"
          alt="powered_by_stripe"
        />
      </div>
    </PaymentSafenessStyles>
  );
};
